import {Navigate, useLocation} from "react-router-dom";
import {useSelector} from "react-redux";
import {selectCurrentToken} from "./authSlice";
import AppShell from "../../layout/shell/AppShell";
import "../../app.css";
import "./main.css";


const RequireAuth = () => {
    const token = useSelector(selectCurrentToken);
    const location = useLocation();

    return token
        ? <AppShell/>
        : <Navigate to="/login" state={{from: location}} replace/>;
};

export default RequireAuth;
